import { usdToTrons } from './products';
import type { RouterOutputs } from './trpc';

// Game constants
export const QUESTIONS_PER_ROUND = 10;
export const TIMER_SECONDS = 15;
export const BASE_TRONS = usdToTrons(0.000333);
export const STREAK_MULTIPLIER = 50;
export const DAILY_BONUS = 500;

// Types derived from tRPC router outputs
export type GameSessionResult = RouterOutputs['games']['startSession'];
export type GameAnswerResult = RouterOutputs['games']['submitAnswer'];
export type GameEndResult = RouterOutputs['games']['endSession'];
export type LeaderboardEntry =
  RouterOutputs['games']['getLeaderboard']['entries'][number];
export type GameStats = RouterOutputs['games']['getMyStats'];
export type DailyChallengeStatus = RouterOutputs['games']['getDailyChallenge'];

export type GamePeriod = 'daily' | 'weekly' | 'allTime';
